import {
  makeAutoObservable,
  observable,
  action,
  computed,
  runInAction,
  toJS,
  autorun,
  onBecomeUnobserved,
  reaction,
} from "mobx";
import { CommonPathWay } from "../../Components/CommonPathWay";
import { commonAxios } from "../ExperianPage/CommonAxios.js";
import { showAlertToast } from "../../Components/ToastComponent/AlertMessage.js";
class PaymentHistyoryStore {
  tableData = {
     filterOptions: [],
    options: [],
  };
  pageSize = 10;
  currentPage = 1;
  totalPages = 0;
  searchInput = "";
  invitePersonEmail = "";
  invitePersonName = "";
  inviteModalShow = false;
  labelErrorMessage = null;
  formSubmitMessageFlag = false;
  allocatedCredits = 0;
  allocateCreditsModalShow = false;
  selectedRow = null;
  inforBarMessage = "";
  inforBarMessageFlag = false;
  removeUserModalShow = false;
  activateuserModalShow = false;
  statusOfUser = "";
  typeOptions = [
    {
      label: "Payment",
      value: "payment",
    },
    { label: "Credit", value: "credit" },
    { label: "Debit", value: "debit" },
  ];
   calendarValue = {
    startDate: new Date(
      new Date().setDate(new Date().getDate() - 7)
    ).toLocaleDateString("en-CA"),
    endDate: new Date().toLocaleDateString("en-CA"),
  };
  selectedType = "";
  constructor(rootstore) {
    this.rootstore = rootstore;
    makeAutoObservable(this);
    reaction(
      () => [this.pageSize, this.currentPage, this.searchInput, this.calendarValue.startDate, this.calendarValue.endDate],
      () => {
        this.searchFunction();
      }
    );
    reaction(
      () => [this.selectedType],
      () => {
        this.handleManageUser();
      }
    );
  }

  setCalendarValue = (value) => {
    this.calendarValue = value;
  };

  handleManageUser = async () => {
    try {
      const response = await CommonPathWay(
        "/credit/log",
        "GET",
        {},
        {
          search: this.searchInput,
          limit: this.pageSize,
          page: this.currentPage,
          type: this.selectedType || "all",
          startDate: this.calendarValue.startDate,
          endDate: this.calendarValue.endDate,
        }
      );
       runInAction(() => {
        this.tableData = response.data;
      });
      if (response?.data) {
        runInAction(() => {
          this.pageSize = response.data?.pagination?.limit || 10;
          this.currentPage = response.data?.pagination.page || 1;
          this.totalPages = response.data?.pagination?.totalPages;
        });
      }
    } catch (e) {
    }
  };
  searchFunction = async (searchTerm) => {
    try {
      const response = 
      await CommonPathWay(
        "/credit/log",
        "GET",
        {},
        {
          search: this.searchInput,
          limit: this.pageSize,
          page: this.currentPage,
          type: this.selectedType || "all",
          startDate: this.calendarValue.startDate,
          endDate: this.calendarValue.endDate,
        }
      );
      runInAction(() => {
        this.tableData = response.data;
      });
      if (response?.data) {
        runInAction(() => {
          // this.pageSize = response.data?.pagination?.limit || 10;
          // this.currentPage = response.data?.pagination.page || 1;
          this.totalPages = response.data?.pagination?.totalPages;
        });
      }
    } catch (e) {
    }
  };
  handleInviteUser = async (e) => {
    e.preventDefault();
    const isValid =
      !this.invitePersonEmail ||
      !this.invitePersonName ||
      this.invitePersonEmail === "" ||
      this.invitePersonName === "";
    if (isValid) {
      this.setLabelErrorMessage("Please fill all the fields");
      return;
    }
    try {
      const response = await commonAxios(
        "/inviteNewMembers",
        "POST",
        {},
        {
          email: this.invitePersonEmail,
          userName: this.invitePersonName,
        }
      );
      showAlertToast({
        title: "Invite User",
        message: "User invited successfully",
        type: "success",
      });
      this.setFormSubmitMessageFlag(true);
      this.setLabelErrorMessage(null);
      this.setInvitePersonEmail("");
      this.setInvitePersonName("");
      this.setInviteModalShow(false);
      this.searchFunction();
    } catch (e) {
      showAlertToast({
        title: "Invite User",
        message: e?.response?.data?.error?.message,
        type: "error",
      });
    }
  };
  handleCreditAllocation = async (e) => {
    e.preventDefault();
    try {
      const response = await commonAxios(
        "/updateCreditToTeamUser",
        "POST",
        {},
        {
          memberId: this.selectedRow?.userId,
          credits: this.allocatedCredits,
        }
      );
      this.setLabelErrorMessage(null);
      this.setAllocateCreditsModalShow(false);
      showAlertToast({
        type: "success",
        message: "Credit Allocated Successfully",
        title: "Credit Allocation",
      });
      // this.setInforBarMessage("Credits Allocated Successfully");
      // this.setInforBarMessageFlag(true);
      // this.setFormSubmitMessageFlag(true);
    } catch (e) {
      this.setLabelErrorMessage(
        e?.response?.data?.error?.message || "Failed to allocate credits"
      );
    }
  };
  handleRemoveUser = async () => {
    try {
      const response = await commonAxios(
        "/removeUser",
        "POST",
        {},
        {
          memberId: this.selectedRow?.userId,
          status: this.statusOfUser,
        }
      );
      showAlertToast({
        type: "success",
        message: "User Removed Successfully",
        title: "User Removal",
      });
      runInAction(() => {
        this.setRemoveUserModalShow(false);
      });
    } catch (e) {
    }
  };
  handleActivateUser = async () => {
    try {
      const response = await commonAxios(
        "/removeUser",
        "POST",
        {},
        {
          memberId: this.selectedRow?.userId,
          status: this.statusOfUser,
        }
      );
      showAlertToast({
        type: "success",
        message: "User Activate Successfully",
        title: "User Activated",
      });
      runInAction(() => {
        this.setActivateModalShow(false);
      });
    } catch (e) {
    }
  };
  handleOptionClick = (row, option) => {
    if (option.label === "Allocate Credits") {
      this.setAllocateCreditsModalShow(true);
      this.setSelectedRow(row);
    }
    if (option.label === "Remove User") {
      this.setRemoveUserModalShow(true);
      this.setSelectedRow(row);
      this.statusOfUser = option.type;
    }
    if (option.label === "Activate User") {
      this.setActivateModalShow(true);
      this.setSelectedRow(row);
      this.statusOfUser = option.type;
    }
  };
  setSearchInput = (value) => {
    this.searchInput = value;
  };
  setPageSize = (size) => {
    this.pageSize = size;
  };
  setCurrentPage = (page) => {
    if (page < 0) {
      this.currentPage = 0;
    } else {
      this.currentPage = page;
    }
  };
  setInvitePersonEmail = (value) => {
    this.invitePersonEmail = value;
  };
  setInvitePersonName = (value) => {
    this.invitePersonName = value;
  };
  setInviteModalShow = (value) => {
    this.inviteModalShow = value;
  };
  setLabelErrorMessage = (value) => {
    this.labelErrorMessage = value;
  };
  setFormSubmitMessageFlag = (value) => {
    this.formSubmitMessageFlag = value;
  };
  setAllocatedCredits = (value) => {
    this.allocatedCredits = value;
  };
  setAllocateCreditsModalShow = (value) => {
    this.allocateCreditsModalShow = value;
  };
  setSelectedRow = (row) => {
    this.selectedRow = row;
  };
  setInforBarMessage = (message) => {
    this.inforBarMessage = message;
  };
  setInforBarMessageFlag = (flag) => {
    this.inforBarMessageFlag = flag;
  };
  setRemoveUserModalShow = (value) => {
    this.removeUserModalShow = value;
  };
  setActivateModalShow = (value) => {
    this.activateuserModalShow = value;
  };
  setSelectedType = (value) => {
    this.selectedType = value;
  };
}
export default PaymentHistyoryStore;
